//import { ContactSupportOutlined } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import ParkingHistoryAccordion from "../../../components/UI/Accordion/ParkingHistoryAccordion/ParkingHistoryAccordion";
import SharePopover from "../../../components/UI/Popovers/SharePopover/SharePopover";
import QuickSearchToolbar from "../../../components/UI/ToolsBar/QuickSearchToolbar/QuickSearchToolbar";
import { TABLES, USER_TYPES } from "../../../enums/Enums";
import Icons from "../../../resources/icons/Icons";
//import { escapeRegExp } from "../../../utils/CommonUtils";
import { downloadReceiptByInvoiceSummaryId } from "../../../utils/MenuUtils";
import classes from "./History.module.css";

const History = (props) => {
  const [parkingHistories, setParkingHistories] = React.useState([]);
  const [showActionsButtons, setShowActionsButtons] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [checkedList, setCheckedList] = useState({});
  const sites = useSelector((state) => state.user.sites);
  
  React.useEffect(() => {
    let isGuest = props?.tableId === TABLES.GUESTS;
    const invoiceSummariesParkingHistoryIds = props.utronUser?.invoiceSummaries?.map(is => is.parkingHistoryId);
    const allParkingHistories = props?.utronUser
      ? [...props?.utronUser?.parkingHistories]
      : [];
    const sortedParkingHistories = allParkingHistories 
    ?.filter(ph =>  isGuest ? invoiceSummariesParkingHistoryIds?.includes(ph.id) || props?.utronUser?.carUserTokens?.find(carUserToken => carUserToken?.token?.id === ph?.tokenId)?.token?.userTypeId === USER_TYPES.TRANSIENT : true)
    ?.sort((a, b) => new Date(b.entranceDate) - new Date(a?.entranceDate));
    setSearchText("");
    setParkingHistories(sortedParkingHistories);
  }, [props?.utronUser?.parkingHistories]);

  React.useEffect(() => {
    setShowActionsButtons(
      Object.values(checkedList).filter((value) => value).length > 0
    );
  }, [checkedList]);

  const requestSearch = (searchValue) => {
    let isGuest = props?.tableId === TABLES.GUESTS;
    const invoiceSummariesParkingHistoryIds = props.utronUser?.invoiceSummaries?.map(is => is.parkingHistoryId);
    const allParkingHistories = props?.utronUser
      ? [...props?.utronUser?.parkingHistories]
      : [];
    const sortedParkingHistories = allParkingHistories 
    ?.filter(ph => isGuest ? invoiceSummariesParkingHistoryIds?.includes(ph.id) || props?.utronUser?.carUserTokens?.find(carUserToken => carUserToken?.token?.id === ph?.tokenId)?.token?.userTypeId === USER_TYPES.TRANSIENT : true)
    ?.sort((a, b) => new Date(b.entranceDate) - new Date(a?.entranceDate));
    setSearchText(searchValue);
    const parkings = [...sortedParkingHistories];
    const filteredRows = parkings.filter((parkingHistory) => { 
      const userSite = sites.find((site) => site.id === parkingHistory.siteId); 
      return userSite?.displayName?.toLowerCase().includes((searchValue).toLowerCase()); 
    });
    
    // const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    // const filteredRows = parkings.filter((parkingHistory) => {
    //   const userSite = sites.find((site) => {
    //     return site.id === parkingHistory.siteId;
    //   });
    //   return searchRegex.test(userSite?.displayName);
    // });
    setParkingHistories(filteredRows);
  };

  const quickSearch = {
    value: searchText,
    onChange: (event) => requestSearch(event.target.value),
    clearSearch: () => requestSearch(""),
  };

  const handleActionChange = (value) => {
    const currentStatus = checkedList[value];
    if (value) {
      setCheckedList((prevState) => ({
        ...prevState,
        [value]: currentStatus ? !currentStatus : true,
      }));
    }
  };

  const downloadSelectedReceipts = () => {
    let invoiceSummariesIds = []
    props.utronUser.invoiceSummaries.map((invoiceSummary) => {
      for (const [key, value] of Object.entries(checkedList)) {
        if (value && invoiceSummary?.parkingHistoryId?.toString() === key) {
          invoiceSummariesIds.push(invoiceSummary.id);
        }
      }
    });
    downloadReceiptByInvoiceSummaryId(invoiceSummariesIds);
  };
  
  const getSelectedInvoiceSummaries= (parkingHistoryId = null) => {
    let selectedArray= [];
    if(parkingHistoryId && parkingHistoryId !== null){
      let selectedInvoice = props.utronUser.invoiceSummaries.find(invoice => invoice.parkingHistoryId === parkingHistoryId);
      if(selectedInvoice){
        selectedArray.push(selectedInvoice.id);
      }
    }
    else{
      props.utronUser.invoiceSummaries.map((invoiceSummary) => {
        for (const [key, value] of Object.entries(checkedList)) {
          console.log(invoiceSummary.parkingHistoryId);
          if (value && invoiceSummary?.parkingHistoryId?.toString() === key) {
            selectedArray.push(invoiceSummary.id);
          }
        }
      });
    }
    return selectedArray;
  }

  return (
    <div>
      <QuickSearchToolbar {...quickSearch} />
      <div className={classes.parkingHistoryAccordion}>
        {parkingHistories?.map((parkingHistory) => (
          <ParkingHistoryAccordion
            key={parkingHistory.id}
            parkingHistory={parkingHistory}
            utronUser={props.utronUser}
            checkedList={checkedList}
            handleActionChange={handleActionChange}
            getSelectedValues={getSelectedInvoiceSummaries}
          ></ParkingHistoryAccordion>
        ))}
      </div>

      {showActionsButtons && (
        <Stack className={classes.actionsButtons} direction="row" spacing={2}>
          <SharePopover 
            userData={props?.utronUser}
            userName={`${props?.utronUser?.firstName} ${props?.utronUser?.lastName}`}
            siteName={props?.utronUser?.userSites[0]?.site?.displayName}
            getSelectedValues={getSelectedInvoiceSummaries}>
            <Button>
              <img src={Icons.SHARE2}></img>
              Share
            </Button>
          </SharePopover>
          <Button onClick={downloadSelectedReceipts}>
            <img src={Icons.DOWNLOAD}></img>
            Download
          </Button>
        </Stack>
      )}
    </div>
  );
};

export default History;
